import { InvestmentChangeConstraints, LumpPostConstraints, LumpPreConstraints, VoluntaryPostConstraints, VoluntaryPostRateConstraints, VoluntaryPreConstraints, VoluntaryPreRateConstraints } from "./client.constraints.model";
import { ClientModel } from "./client.model";
import { NavigationModel } from "./navigation.model";
import { environment } from "src/environments/environment";
import { TestingModel } from "./testing.model";
declare var require: any;

export interface ISidebarEmitterModel {
    isSidebarOpen: boolean;
    data?: any;
}

export interface IViewStates {
    isDisclaimerAccepted: boolean;
}


export interface IInvestmentChanges {
    current: IInvestmentChange;
    future: IInvestmentChange;
}

export interface IInvestmentChange {
    Cash: number;
    Conservative: number;
    Balanced: number;
    Growth: number;
    Aggressive: number;
    Glidepath: number;
}

export interface IKeyValuePair {
    key: string;
    value: any;
}

export class EditedContentModel {
    elementKey: string = null;
    htmlTemplate: any = null;
    isEditingInline: boolean = false;
    content: any = null;
    constructor(elementKey: string, htmlTemplate: string, isEditingInline?: boolean, content?: any) {
        this.elementKey = elementKey;
        this.htmlTemplate = htmlTemplate;
        if (isEditingInline !== undefined) {
            this.isEditingInline = isEditingInline;
        }
        if (content !== undefined) {
            this.content = content;
        }
    }
}

export interface IEditedContentModel {
    elementKey: string;
    htmlTemplate: any;
    content: any;
    isEditingInline?: boolean;
}

export class CalculatorModel {

    calculatorKey: string = null;

    members: any;
    memberInitial: any = null;
    results: any;
    contents: any;
    constraints: any;
    clientModel: ClientModel;
    navigationModel: NavigationModel = new NavigationModel({});
    testingModel: TestingModel = new TestingModel();

    maxTimeAllowed = 70;
    isWorkPatternsAddingAllowed = true;
    isUnitTesting: boolean = false;
    isDefaultSet_ageR: boolean = false;
    currentScenario: string = "current";
    isDisclaimerAccepted: boolean = false;

    constructor(obj: any) {

        this.clientModel = new ClientModel();

        if (obj.hasOwnProperty('members')) {
            this.members = obj.members;
        }

        if (obj.hasOwnProperty('results')) {
            this.results = obj.results;
        }

        if (obj.hasOwnProperty('content')) {
            this.contents = obj.content;
        }

    }

    // get member(): any {
    //     if (this.members) {
    //         return this.members['current'];
    //     }
    //     else {
    //         return null;
    //     }
    // }

}

export class SalaryChangeModel {
    reason: string = "";
    change: number;
    time: number;

    constructor(obj: any) {
        if (obj.hasOwnProperty('change') && !isNaN(obj.change)) {
            this.change = obj.change;
        }

        if (obj.hasOwnProperty('time') && !isNaN(obj.time)) {
            this.time = obj.time;
        }

        if (obj.hasOwnProperty('reason') && !isNaN(obj.reason)) {
            this.reason = obj.reason;
        }
    }
}

export class WorkingPatternModel {
    reason: string = "";
    workRate: number = 0;
    time: number = 0;
    length: number = 0;

    constructor(obj: any) {
        if (obj.hasOwnProperty('workRate') && !isNaN(obj.workRate)) {
            this.workRate = obj.workRate;
        }

        if (obj.hasOwnProperty('time') && !isNaN(obj.time)) {
            this.time = obj.time;
        }

        if (obj.hasOwnProperty('length') && !isNaN(obj.length)) {
            this.length = obj.length;
        }

        if (obj.hasOwnProperty('reason') && !isNaN(obj.reason)) {
            this.reason = obj.reason;
        }
    }
}
